import { createUseStyles } from 'react-jss'

import { darkBlue } from '../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  goal: {
    color: darkBlue
  }
})

export default useStyles
